import { useBulkUpdateItems, useUpdateItem } from "~/hooks/useData";

const useSetNotificationAsRead = () => {
  const updateNotification = useUpdateItem({ collection: "notifications" });
  const bulkUpdateNotification = useBulkUpdateItems({
    collection: "notifications",
  });

  const markAsRead = async (notificationId: string) => {
    const updatedNotification = await updateNotification({
      id: notificationId,
      arg: {
        markedRead: true,
      },
    });

    return updatedNotification;
  };

  const markAsReadBulk = async (notificationIds: string[]) => {
    const updatedNotifications = await bulkUpdateNotification({
      ids: notificationIds,
      arg: {
        markedRead: true,
      },
    });

    return updatedNotifications;
  };

  return { markAsRead, markAsReadBulk };
};

export default useSetNotificationAsRead;
